module.exports = __webpack_public_path__ + "img/dot.eb9e4581.png";